import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const Icon = ({ sx = {}, icon, height, width, alt, ...others }) => {
  const defaultStyles = {
    height: '30px',
    width: '30px',
    borderRadius: '10px',
  };

  const combinedStyles = { ...defaultStyles, ...sx };

  return (
    <Box
      component="img"
      alt={alt}
      height={height}
      width={width}
      src={icon}
      sx={combinedStyles}
      {...others}
    />
  );
};

Icon.propTypes = {
  sx: PropTypes.object,
  icon: PropTypes.string.isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  alt: PropTypes.string,
};

export default Icon;
